<pdp-clone-request [request]="request"
                   (cloningOptionsChange)="cloningOptionsChanged($event)"
                   (contractIdsChange)="contractIdsChanged($event)"></pdp-clone-request>
<kendo-dialog-actions layout="normal">
  <button themeColor="secondary" kendoButton (click)="onAction('cancel')">{{'cancel'|i18n}}</button>
  <button themeColor="primary" kendoButton (click)="onAction('clone')" [disabled]="contractIds.length<1">{{'ok'|i18n}}</button>
</kendo-dialog-actions>

